import React from 'react';
import { Data } from '../../types/data-providers';
import { useData, dataFromDataset } from './DataProviderCache';
import * as ChartManager from '../domain/chart-manager';
import { useAuthHelper } from '../../components/AuthContextProvider';
import { QmaxData } from '../../types/device';
type contextState = Data<QmaxData>;
const context = React.createContext<contextState | null>(null);

function useQmaxGraphDetail(): contextState {
    const contextState = React.useContext(context);
    if (contextState === null) {
        throw new Error('useQmaxGraph details must be used within a maxQmax Graph');
    }
    return contextState;
}
const MaxQmaxGraphProvider: React.FC<{ deviceId: string; channelNumber: any; startDate: string; endDate: string }> = (props) => {
    const authHelper = useAuthHelper();
    const { dataset } = useData({
        cacheKey: 'maxQmax-Graph',
        id: `${props.deviceId}-${props.channelNumber}-${props.startDate}-${props.endDate}`,
        dataFn: React.useCallback(
            (): Promise<QmaxData> => ChartManager.getQmaxApiResponse(authHelper, props.deviceId, props.channelNumber,props.startDate,props.endDate),
            [authHelper, props.deviceId, props.channelNumber,props.startDate,props.endDate]
        ),
    });

    const maxQmaxResponseData = dataFromDataset(dataset);

    return <context.Provider value={maxQmaxResponseData}>{props.children}</context.Provider>;
};

const TestMaxQmaxGraphProvider: React.FC<{ value: contextState }> = (props) => <context.Provider value={props.value}>{props.children}</context.Provider>;

export { MaxQmaxGraphProvider, TestMaxQmaxGraphProvider, useQmaxGraphDetail };
